export enum AssetFamilyTypeRoutes {
  Battery = 'app-battery',
  BatteryBank = 'app-battery-bank',
  Biogas = 'app-biogas',
  EnergyConsumer = 'app-energy-consumer',
  FireAlarmSystem = 'app-forms',
  Generator = 'app-generator',
  Hydro = 'app-hydro',
  PowerGrid = 'app-power-grid',
  SolarPv = 'app-solar-pv',
  Wind = 'app-wind',
}
